import * as common from './common';
import * as exportsArea from './exports';
import * as v1 from './v1';
import * as v2 from './v2';

/** Every area's catalog. Keys are unique across areas (a test checks it). */
export const AREAS = { common, v1, v2, exports: exportsArea };

const en = { ...common.en, ...v1.en, ...v2.en, ...exportsArea.en };

export type MessageKey = keyof typeof en;
/** A plural message: the key without its _one / _few / _other suffix. */
export type PluralKey = MessageKey extends infer K ? (K extends `${infer Base}_other` ? Base : never) : never;

const sr: Record<MessageKey, string> = { ...common.sr, ...v1.sr, ...v2.sr, ...exportsArea.sr };

export const MESSAGES: Record<'sr' | 'en', Record<MessageKey, string>> = { sr, en };
